import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class Business extends PolygonMapItem {
    public override TypeName: string = "BusinessDirectory";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";
    
    constructor(formGroup: FormGroup) {
        super(formGroup, "BusinessDirectory");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('EntrySegment')) {
            formGroup.addControl('EntrySegment', new FormControl(null));
        }
        
        // Default colors from BusinessTool
        this.OutlineColor = '#555555';
        this.FillColor = '#e8e8e8';
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Business Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'EntrySegment',
                displayName: 'Entry Location',
                inputType: { 
                    type: 'number',
                    min: 0,
                    max: 10
                },
                description: 'Index of the wall segment that contains the entry (0-3)',
                order: 2,
                category: 'Properties'
            }
        ];
    }

    public override default(): Business {
        // Default 6x6 meter business space
        this.points = [
            { x: 0, y: 0 },
            { x: 6, y: 0 },
            { x: 6, y: 6 },
            { x: 0, y: 6 }
        ];
        return this;
    }

    public override clone(): Business {
        return new Business(this.formGroup);
    }

    public override draw(ctx: CanvasRenderingContext2D, offsetX: number = 0, offsetY: number = 0): void {
        super.draw(ctx, offsetX, offsetY);

        // If there's an entry segment, draw it differently
        const entrySegment = this.formGroup.get('EntrySegment')?.value;
        if (entrySegment !== null && entrySegment >= 0 && entrySegment < this.points.length) {
            const scale = ctx.getTransform().a;
            const lineWidth = 2 / scale;
            
            ctx.beginPath();
            const startPoint = this.points[entrySegment];
            const endPoint = this.points[(entrySegment + 1) % this.points.length];
            
            ctx.moveTo(startPoint.x + offsetX, startPoint.y + offsetY);
            ctx.lineTo(endPoint.x + offsetX, endPoint.y + offsetY);
            
            // Draw entry segment in a different color
            ctx.strokeStyle = '#4CAF50'; // Green color for entry
            ctx.lineWidth = lineWidth * 2; // Thicker line for entry
            ctx.stroke();
        }
    }
} 
